import React, { useEffect } from "react";
//import { Link } from 'react-router-dom';
import { useSearchParams} from 'react-router-dom';

import { DriveItem, ThumbnailSet,Thumbnail,NullableOption } from "@microsoft/microsoft-graph-types";
import {ViewMode} from './DirectoryList';
import { FolderDataFileEntry } from '../graph'
import SVG_FolderOpened from '../FolderOpened.svg'
import SVG_OneLevelUp from '../OneLevelUp.svg'
import SVG_Document from '../Document.svg'


const getSize = (set : ThumbnailSet, viewMode:ViewMode) : NullableOption<Thumbnail>|undefined=> {
  if( viewMode == "small")
    return set.small;
  else if( viewMode == "medium")
    return set.medium;
  else if( viewMode == "large")
    return set.large;
  else 
    return set.source;
}

export const DriveItemComponent = (props: { viewMode:ViewMode, item: DriveItem, extraInfo: FolderDataFileEntry|null, parentLocation: string }): JSX.Element => {
  var imageTag: JSX.Element = <img className='image' src={ SVG_FolderOpened } width='64' height='64' />;

  let [_, setSearchParams] = useSearchParams();

  if (props.item.thumbnails != null && props.item.thumbnails.length > 0 ) {
    var thumbnailZero = props.item.thumbnails[0];
    
    var imageBody = getSize(thumbnailZero, props.viewMode);
    var imageUrl = imageBody ? imageBody.url : null;
    if (imageUrl !== null) {
      imageTag = <img className='image' src={imageUrl} />;
    }
  }

  var description = 'No description yet!';
  if( props.extraInfo != null ) {
    description = props.extraInfo.Description;
  }



  if(props.item.folder) {
    const targetUrl = props.parentLocation == '/' 
    ? '/' + props.item.name
    : props.parentLocation + '/' + props.item.name;

    const clickItem = () => {
      setSearchParams( {path:targetUrl});
   }
    return (
      <div className='folder' onClick={clickItem}>
          <div className='caption'>{props.item.name}</div>
          {imageTag}
      </div>);

  } else {
    const targetUrl : string = props.item.webUrl || '';

    return (
      <div className='folder'>
          <a href={targetUrl}>
          <div className='caption'>{props.item.name}</div>
          {imageTag}
          </a>
          <input type='text' value={description}></input>
      </div>);
  }

};


export const DriveItemComponentParent = (props: { parentLocation: string }): JSX.Element => {
  let [_, setSearchParams] = useSearchParams();

  const parentOf = (location:string) : string => {
    var bits = location.split('/');
    bits.pop();
    return bits.join('/');
  }
  const clickItem = () => {
    setSearchParams( {path:parentOf(props.parentLocation)});
 }  

  return (
    <div className='folder' onClick={clickItem}>
        <div className='caption'>Parent</div>
        <img className='image' src={SVG_OneLevelUp} width='64' height='64' />
    </div>
  );
};
